import { EtapaEmpenho } from '../../../../types/empenhos';

export const ETAPA_LABELS: Record<EtapaEmpenho, string> = {
  PLANEJAMENTO: 'Planejamento',
  COMPRAS: 'Compras',
  PAGAMENTO: 'Pagamento',
  PAGO: 'Pago',          // legado
  NF_ENTRADA: 'NF de Entrada',
  NF_SAIDA: 'NF de Saída',
  ENTREGA: 'Entrega',
  CONCLUIDO: 'Concluído',
  CANCELADO: 'Cancelado'
};

export const ETAPA_BADGE: Record<EtapaEmpenho, string> = {
  PLANEJAMENTO: 'badge-soft-secondary',
  COMPRAS: 'badge-soft-info',
  PAGAMENTO: 'badge-soft-warning',
  PAGO: 'badge-soft-success',          // legado
  NF_ENTRADA: 'badge-soft-teal',
  NF_SAIDA: 'badge-soft-purple',
  ENTREGA: 'badge-soft-success',
  CONCLUIDO: 'badge-soft-success',
  CANCELADO: 'badge-soft-danger'
};

export const ETAPA_ICONS: Record<EtapaEmpenho, string> = {
  PLANEJAMENTO: 'clipboard',
  COMPRAS: 'shopping-cart',
  PAGAMENTO: 'credit-card',
  PAGO: 'check-circle',                // legado
  NF_ENTRADA: 'file-invoice',
  NF_SAIDA: 'file-invoice-dollar',
  ENTREGA: 'box',
  CONCLUIDO: 'circle-check',
  CANCELADO: 'times-circle'
};

// Ordem das etapas no fluxo ativo (para barra de progresso)
export const ETAPAS_FLUXO: EtapaEmpenho[] = [
  'COMPRAS',
  'PAGAMENTO',
  'NF_ENTRADA',
  'NF_SAIDA',
  'ENTREGA',
  'CONCLUIDO',
];

export function getEtapaLabel(etapa: EtapaEmpenho): string {
  return ETAPA_LABELS[etapa] ?? etapa;
}

export function getEtapaBadge(etapa: EtapaEmpenho): string {
  return ETAPA_BADGE[etapa] ?? 'badge-soft-secondary';
}

export function getEtapaIcon(etapa: EtapaEmpenho): string {
  return ETAPA_ICONS[etapa] ?? 'circle';
}

export function isNovoFluxo(etapa: EtapaEmpenho): boolean {
  return ['COMPRAS', 'PAGAMENTO', 'NF_ENTRADA', 'NF_SAIDA', 'ENTREGA', 'CONCLUIDO'].includes(etapa);
}

export function getProximaEtapa(etapa: EtapaEmpenho): EtapaEmpenho {
  if (etapa === 'COMPRAS') return 'PAGAMENTO';
  if (etapa === 'PAGAMENTO') return 'NF_ENTRADA';
  if (etapa === 'NF_ENTRADA') return 'NF_SAIDA';
  if (etapa === 'NF_SAIDA') return 'ENTREGA';
  if (etapa === 'ENTREGA') return 'CONCLUIDO';
  return etapa;
}

export function getEtapaAnterior(etapa: EtapaEmpenho): EtapaEmpenho | null {
  if (etapa === 'PAGAMENTO') return 'COMPRAS';
  if (etapa === 'NF_ENTRADA') return 'PAGAMENTO';
  if (etapa === 'NF_SAIDA') return 'NF_ENTRADA';
  if (etapa === 'ENTREGA') return 'NF_SAIDA';
  if (etapa === 'CONCLUIDO') return 'ENTREGA';
  return null;
}
